import { Component, OnInit } from '@angular/core';
import { OtpremnicaService } from './otpremnica.service';
import { PdfZaOtpremniceService } from 'src/app/pdf-ovi/pdfZaOtpremnice.service';
import { moduli } from '../../config';
import moment from 'moment';
import notify from 'devextreme/ui/notify';
import { custom } from 'devextreme/ui/dialog';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-otpremnica',
  templateUrl: './otpremnica.component.html',
  styleUrls: ['./otpremnica.component.scss'],
  providers: [OtpremnicaService]
})

export class OtpremnicaComponent implements OnInit {

  idkorisnik: any;
  access_token: any;
  idfirma: any;

  otpremnice = [];
  stavke = [];
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  idOtpremnice: number;
  poruka: string;
  naslov: string;
  dozvoliUredivanje: any = false;
  pocetni_provjera: any = [];
  partner_pa_id: any;
  poslovnicaPartnera_id: any;
  poslovnicePartneraFilter = [];
  poslovnicePartnera = [];
  poslovnicePekar = [];
  partneri = [];
  prijevoznici = [];
  odabraniPartner: any;
  sviProizvodi: any;
  odabraniProizvod: any;
  sviLotovi: any = [];
  odabraniLot: any;
  lotBroj: any;
  kolicina: any;
  brojKutija: any;
  idProizvoda: any;
  sifraArtikla: any;
  idDokumenta: number;
  statusDokumenta: any;
  programKreiranja: any;
  prometzag_pz_idVezni: any;
  odabraniRed: any;
  poslovnica_po_id: any;
  sviArtikli_poslovnica: any = [];
  sviLotovi_poslovnica: any = [];
  isLoading: boolean = true;
  artikl_lot: any;
  sviLotovi_artikla: any = [];
  disableGumb: boolean = false;
  zadnjId: any = null;
  redIzmjenjen: boolean = false;

  prikazi: any = [
    { idprikaz: 1, pr_naziv: 'DA' },
    { idprikaz: 0, pr_naziv: 'NE' }
  ];

  povezaniDokumentiPopup = false;
  povezani_dokumenti: any = [];
  window: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private service: OtpremnicaService,
    private otpremniceService: PdfZaOtpremniceService,
  ) {
    this.idkorisnik = localStorage.getItem('idsecuser');
    this.access_token = sessionStorage.getItem('token');
    this.idfirma = localStorage.getItem('firma');

    this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
    this.dohvatiPoslovnicePekar();
    this.dohvatiPartnere_i_poslovnice();
    this.dohvatiPrijevoznike();
    this.partnerOdabran = this.partnerOdabran.bind(this);
    this.poslovnicaOdabrana = this.poslovnicaOdabrana.bind(this);
    this.odabranArtikl = this.odabranArtikl.bind(this);
    this.poslovnicaPartneraOdabrana = this.poslovnicaPartneraOdabrana.bind(this);
    this.odabranLot = this.odabranLot.bind(this);

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().otpremnice;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onRowClick(e) {
    if (
      e.rowType === 'data' &&
      e.handled !== true &&
      e.event.target.className !== 'dx-button-text'
    ) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onInitNewRow(e: any) {
    this.dozvoliUredivanje = true;
    this.sviLotovi_artikla = [];
    this.naslov = 'Dodavanje';
    e.data.pz_datum = moment();
  }

  dodajOtpremnicu(e: any) {
    this.zadnjId = null;
    let odabranaPoslovnica = this.poslovnicePekar.filter(poslovnica => poslovnica.idposlovnica === e.data.poslovnica_po_id);
    let odabranaPoSifra = odabranaPoslovnica[0].po_sifra;
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      datum: moment(e.data.pz_datum).format('YYYY-MM-DD'),
      godina: moment(e.data.pz_datum).format('YYYY'),
      poslovnica_po_id: e.data.poslovnica_po_id,
      partner_pa_id: e.data.partner_pa_id,
      poslovnicapartnera_pp_id: e.data.poslovnicapartnera_pp_id,
      prijevoznik: e.data.partner_pa_id_vezni,
      registracija_vozila: e.data.pz_registracijavozila,
      posifra: odabranaPoSifra,
      dv_sifra: "OTPREM"

    };
    this.service.dodajOtpremnicu(podaciZaSlanje).subscribe((res) => {
      if (res.success === true) {
        //this.zadnjId = res.data[0].pz_id;
        notify('Uspješno dodana otpremnica.', 'success', 3000);
        this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId)
      } else {
        notify(res.message, 'error', 3000);
      }
    });

  }

  urediOtpremnicu(e: any) {
    if (e.data.pz_status != 'Z') {
      const data = {
        pz_id: e.data.pz_id,
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: this.idfirma,
        pz_datum: moment(e.data.pz_datum).format('YYYY-MM-DD'),
        registracija_vozila: e.data.pz_registracijavozila,
        partner_pa_id: e.data.partner_pa_id,
        poslovnicapartnera_pp_id: this.poslovnicaPartnera_id,
        prijevoznik: e.data.partner_pa_id_vezni,
        idposlovnicapartnera: e.data.poslovnicapartnera_pp_id,
        poslovnica_po_id: e.data.poslovnica_po_id,
      };

      this.service.prometzagUredi(data).subscribe((res) => {
        if (res.success === true) {
          this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
          this.poslovnica_po_id = e.data.poslovnica_po_id;
          this.dohvatiArtikleZaPoslovnicu()
          this.artikli_u_cjeniku_za_partnera()
          e.component.collapseAll(-1);
          this.redIzmjenjen = true;
          notify('Uspješno uređena otpremnica.', 'success', 3000);
        }
      });
    } else {
      notify('Nije moguće mjenjati završeni dokument.', 'warning', 3000);
    }
  }

  obrisiOtpremnicu(e: any) {
    this.zadnjId = null;
    if(e.data.pz_status != 'Z') {
      this.service.prometzagObrisi({pz_id: e.data.pz_id, idkorisnik: this.idkorisnik, idfirma: this.idfirma}).subscribe((res) => {
        if (res.success === true) {
          this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
          notify('Uspješno obrisana otpremnica.', 'success', 3000);
        }
      });
    } else {
        notify('Nije moguće mjenjati završeni dokument.', 'warning', 3000);
    }
  }

  zavrsiDokument(e) {
    this.zadnjId = null;
    if(e.data.pz_status == 'I' && this.stavke.length > 0) {
      let myDialog = custom({
        title: "Završi dokument",
        messageHtml: "Jeste li sigurni da želite završiti dokument?",
        buttons: [{
          text: "DA",
          onClick: (e) => {
            return { buttonText: e.component.option("text") }
          }
        },
        {
          text: "NE",
          onClick: (e) => {
            return { buttonText: e.component.option("text") }
          }
        }]
      });
      myDialog.show().then((dialogResult: any) => {
        if (dialogResult.buttonText === 'DA') {
          this.service.zavrsiOtpremnicu({pz_id: e.data.pz_id, idkorisnik: this.idkorisnik, idfirma: this.idfirma}).subscribe(res => {
            if (res.success == true) {
              this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
              notify('Uspješno ste završili dokument.', 'success');
            } else {
              notify(res.message, 'error');
            }
          });
        } else { }
      });
    } else {
        notify('Otpremnica nema stavke.', 'error');
    }
  }

  onCellPrepared(options) {
    if (options.rowType === 'data') {
      if (options.column.dataField === "pz_status") {
        if (options.value == 'I') {
          options.cellElement.classList.add('circleYellow');
        }
        if (options.value == 'U') {
          options.cellElement.classList.add('circleBlue');
        }
        if (options.value == 'S') {
          options.cellElement.classList.add('circleRed');
        }
        if (options.value == 'Z') {
          options.cellElement.classList.add('circleGreen');
        }
      }
    }

    if (options.rowType === 'data' && (options.data?.pz_status === 'Z' || options.data?.pz_status === 'S')) {
      if (options.cellElement.querySelector('.dx-link-edit')) {
        const editLink = options.cellElement.querySelector('.dx-link-edit');
        (editLink as HTMLElement).style.display = 'none';
      }

      if(options.cellElement.querySelector('.dx-link-delete')) {
        const editLink = options.cellElement.querySelector('.dx-link-delete');
        (editLink as HTMLElement).style.display = 'none';
      }
    }
  }

  dohvatiSveProizvode() {
    this.service.dohvatiSveProizvode({}).subscribe((res) => {
      this.sviProizvodi = [];

      if (res.success === true) {
        for (let data of res.data) {
          this.sviProizvodi.push({
            id: data.ar_id,
            sifra: data.ar_sifra,
            naziv: data.ar_naziv,
            sifraNaziv: data.sifrainaziv,
          });
        }
      }
    });
  }

  dohvatiArtikleZaPoslovnicu(){
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: Number(localStorage.getItem('firma')),
        idposlovnica: this.poslovnica_po_id,
        pz_id: this.idOtpremnice
      };
      this.sviLotovi_poslovnica = [];
      this.service.artiklPopisZaPoslovnicu(podaciZaSlanje).subscribe(res=>{
        if (res.success === true) {
          //this.sviArtikli_poslovnica = res.data.artikli;
          this.sviLotovi_poslovnica = res.data.lotovi;
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }

  artikli_u_cjeniku_za_partnera() {
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: Number(localStorage.getItem('firma')),
        partner_pa_id: this.partner_pa_id
      };
      this.sviArtikli_poslovnica = [];
      this.service.artikli_u_cjeniku_za_partnera(podaciZaSlanje).subscribe(res=>{
        if (res.success === true) {
          //console.log(res)
          //console.log(res.data[0])
          this.sviArtikli_poslovnica = res.data;
          //console.log("sviArtikli_poslovnica", this.sviArtikli_poslovnica)
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }

  dohvatiSveLotove(id: number) {
    let podaciZaSlanje = {
      arid: id,
    };

    this.sviLotovi = [];
    this.service.dohvatiSveLotove(podaciZaSlanje).subscribe((res) => {
      if (this.idProizvoda) {
        for (let data of res.podaci.data) {
          this.sviLotovi.push({
            lotBroj: data.ar_lot,
          });
        }
      }
    });
  }

  onChangeProizvodId(e) {
    this.idProizvoda = e.value.id;
    this.sifraArtikla = e.value.sifra;

    if (this.idProizvoda !== null) {
      this.dohvatiSveLotove(this.idProizvoda);
    }
  }

  onChangeLot(e) {
    this.lotBroj = e.value;
    this.dohvatiSveLotove(this.idProizvoda);
  }

  onChangeKolicina(e) {
    this.kolicina = e.value;
  }

  onChangeKutije(e) {
    this.brojKutija = e.value;
  }

  dodajStavku(e) {
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.idOtpremnice,
      poslovnica_po_id: this.poslovnica_po_id,
      idartikl: e.data.artikl_ar_id,
      ar_lot: e.data.ar_lot,
      ps_izlaz: e.data.ps_izlaz
    }
    this.service.tmpprometstavkeDodaj(podaciZaSlanje).subscribe((res) => {
      if (res.success === true) {
        notify('Uspješno dodana stavka.', 'success', 3000);
      } else {
        notify(res.message, 'error', 3000);
      }
      this.dohvatiStavke();
    });

    this.odabraniProizvod = '';
    this.odabraniLot = '';
    this.lotBroj = '';
    this.kolicina = null;
    this.brojKutija = null;
  }

  odabranArtikl(e: any){
    this.artikl_lot = '';
    this.sviLotovi_artikla = [];
    let vazido = '';
    for (let i = 0; i < this.sviLotovi_poslovnica.length; i++) {
      if (e.itemData.ar_id == this.sviLotovi_poslovnica[i].artikl_ar_id) {
        if(this.sviLotovi_poslovnica[i].ar_vazido != null){
          vazido = moment(this.sviLotovi_poslovnica[i].ar_vazido).format('DD.MM.YYYY');
        }else{
          vazido = '';
        }

        this.sviLotovi_artikla.push({
          ar_datum: this.sviLotovi_poslovnica[i].ar_datum,
          ar_lot: this.sviLotovi_poslovnica[i].ar_lot,
          ar_lotstanje: this.sviLotovi_poslovnica[i].ar_lotstanje,
          ar_sifra: this.sviLotovi_poslovnica[i].ar_sifra,
          ar_vazido: this.sviLotovi_poslovnica[i].ar_vazido,
          artikl_ar_id: this.sviLotovi_poslovnica[i].artikl_ar_id,
          firma_fi_id: this.sviLotovi_poslovnica[i].firma_fi_id,
          lb_datizmjene: this.sviLotovi_poslovnica[i].lb_datizmjene,
          lb_id: this.sviLotovi_poslovnica[i].lb_id,
          lot_id_adt: this.sviLotovi_poslovnica[i].lot_id_adt,
          po_sifra: this.sviLotovi_poslovnica[i].po_sifra,
          poslovnica_po_id: this.sviLotovi_poslovnica[i].poslovnica_po_id,
          ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno: moment(this.sviLotovi_poslovnica[i].ar_datum).format('DD.MM.YYYY') + ' - Rok: ' + vazido + ' ' + this.sviLotovi_poslovnica[i].ar_lot + ', ' + this.sviLotovi_poslovnica[i].ar_lotstanje_spojeno,
        });
      } 
    }
  }

  odabranLot(e){
    this.artikl_lot = e.itemData.ar_lot;
  }

  urediStavku(e) {
    const data = {
      idkorisnik: this.idkorisnik,
      idartikl: e.data.artikl_ar_id,
      idfirma: this.idfirma,
      access_token: this.access_token,
      ps_izlaz: e.data.ps_izlaz,
      pz_id: this.idOtpremnice,
      idtmpprometstavke: e.data.ps_id,
      ar_lot: e.data.ar_lot
    };
    this.service.tmpprometstavkeUredi(data).subscribe((res) => {
      if (res.success === true) {
        notify('Uspješno uređena stavka.', 'success', 3000);
      } else {
        notify(res.message, 'error', 3000);
      }
      this.dohvatiStavke();
    });
  }

  obrisiStavku(e) {
    const data = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: this.idOtpremnice,
      idtmpprometstavke: e.data.ps_id
    };
    this.service.tmpprometstavkeObrisi(data).subscribe((res) => {
      if (res.success === true) {
        notify('Uspješna obrisana stavka.', 'success', 3000);
      }
      this.dohvatiStavke();
    });
  }


  dohvatiStavke() {
    this.stavke = [];

    if(this.statusDokumenta == 'I') {
      this.service.tmpprometstavkePopis({ pz_id: this.idOtpremnice, idfirma: this.idfirma, idkorisnik: this.idkorisnik }).subscribe((res) => {
        if (res.success === true) {
          this.stavke = res.data;
        }
      });
    } else {
      this.service.dohvatiJednuOtpremnicu({ pz_id: this.idOtpremnice, idfirma: this.idfirma, idkorisnik: this.idkorisnik }).subscribe((res) => {
        if (res.success === true) {
          this.stavke = res.data;
        }
      });
    }
  }

  onEditingStart(e) {
    this.naslov = "Uređivanje";
    if (e.data.pz_status == 'Z') {
      this.dozvoliUredivanje = false;
    } else {
      this.dozvoliUredivanje = true;
    }

    this.pocetni_provjera = e.data;
    this.poslovnicaPartnera_id = e.data.poslovnicapartnera_pp_id;

    let ppFilter = [];
    ppFilter = this.poslovnicePartnera.filter(function (a) { return a.partner_pa_id == e.data.partner_pa_id; })
    this.poslovnicePartneraFilter = ppFilter;

    this.artikl_lot = e.data.ar_lot;
    if(e.data.artikl_ar_id){
      this.sviLotovi_artikla = [];
      let vazido = '';
      for (let i = 0; i < this.sviLotovi_poslovnica.length; i++) {
        if (e.data.artikl_ar_id == this.sviLotovi_poslovnica[i].artikl_ar_id) {

          if(this.sviLotovi_poslovnica[i].ar_vazido != null){
            vazido = moment(this.sviLotovi_poslovnica[i].ar_vazido).format('DD.MM.YYYY');
          }else{
            vazido = '';
          }

          this.sviLotovi_artikla.push({
            ar_datum: this.sviLotovi_poslovnica[i].ar_datum,
            ar_lot: this.sviLotovi_poslovnica[i].ar_lot,
            ar_lotstanje: this.sviLotovi_poslovnica[i].ar_lotstanje,
            ar_sifra: this.sviLotovi_poslovnica[i].ar_sifra,
            ar_vazido: this.sviLotovi_poslovnica[i].ar_vazido,
            artikl_ar_id: this.sviLotovi_poslovnica[i].artikl_ar_id,
            firma_fi_id: this.sviLotovi_poslovnica[i].firma_fi_id,
            lb_datizmjene: this.sviLotovi_poslovnica[i].lb_datizmjene,
            lb_id: this.sviLotovi_poslovnica[i].lb_id,
            lot_id_adt: this.sviLotovi_poslovnica[i].lot_id_adt,
            po_sifra: this.sviLotovi_poslovnica[i].po_sifra,
            poslovnica_po_id: this.sviLotovi_poslovnica[i].poslovnica_po_id,
            ar_datum_ar_vazido_ar_lot_ar_lotstanje_spojeno: moment(this.sviLotovi_poslovnica[i].ar_datum).format('DD.MM.YYYY') + ' - Rok: ' + vazido + ' ' + this.sviLotovi_poslovnica[i].ar_lot + ', ' + this.sviLotovi_poslovnica[i].ar_lotstanje_spojeno,
          });
        } 
      }
    }
  }

  dohvatiPrijevoznike() {
    this.prijevoznici = [];
    this.service.dohvatiPrijevoznike({}).subscribe((res) => {
      if (res.success === true) {
        this.prijevoznici = res.data;
      }
    });
  }

  dohvatiPoslovnice() {
    this.poslovnicePekar = [];
    this.service.poslovnicaPopis({ idfirma: this.idfirma }).subscribe((res) => {
      if (res.success === true) {
        this.poslovnicePekar = res.data;
      }
    });
  }

  dohvatiPartnere_i_poslovnice() {
    this.partneri = [];
    this.poslovnicePartnera = [];
    this.service.dohvatiPartnere({ idkorisnik: this.idkorisnik, idfirma: this.idfirma }).subscribe((res) => {
      if (res.success === true) {
        this.partneri = res.data.partneri.filter(partner => partner.firma_fi_id === 2);
        this.poslovnicePartnera = res.data.poslovnicepartnera;
      }
    });
  }

  partnerOdabran(e) {
    this.poslovnicaPartnera_id = null;

    if (this.pocetni_provjera && this.pocetni_provjera.partner_pa_id == e.itemData.pa_id) {
      this.poslovnicaPartnera_id = this.pocetni_provjera.poslovnicapartnera_pp_id;
    }

    this.partner_pa_id = e.itemData.pa_id;

    let ppFilter = [];
    ppFilter = this.poslovnicePartnera.filter(function (a) { return a.partner_pa_id == e.itemData.pa_id; })
    this.poslovnicePartneraFilter = ppFilter;
  }

  poslovnicaPartneraOdabrana(e) {
    this.poslovnicaPartnera_id = e.itemData.pp_id;
    this.pocetni_provjera.poslovnicapartnera_pp_id = this.poslovnicaPartnera_id;
  }

  poslovnicaOdabrana(e) {
    this.poslovnica_po_id = e.itemData.pp_id;
    this.pocetni_provjera.poslovnica_po_id = this.poslovnica_po_id;
  }

  // onShowing(e: any) {
  //   e.component.option("title", this.naslov);
  // }

  pdfOtpremnica(data) {
    //console.log(data);
    //console.log(data.data);
    this.otpremniceService.pdfOtpremnica(data);
  }

  ngOnInit(): void {
  }

  dohvatiOtpremnice(datumod, datumdo, zadnjiid): void {
    this.poruka = 'Učitavanje...';
    this.otpremnice = [];
    const data = {
      datumod: datumod,
      datumdo: datumdo,
      pz_id: this.zadnjId
    };
    this.service.dohvatiOtpremnice(data).subscribe((res) => {
      if (res.success === true) {
        this.otpremnice = res.data;
      }

      if (this.otpremnice.length > 0) {
        this.poruka = 'Učitavanje...';
      } else {
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }


  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    //this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
  }
  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    //this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
  }

  onSelectionChanged(e: any): void {
    e.component.collapseAll(-1);
    this.isLoading = true;

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      if(e.selectedRowsData[0].pz_status == 'Z' || e.selectedRowsData[0].pz_status == 'S'){
        this.dozvoliUredivanje = false;
      }else{
        this.dozvoliUredivanje = true;
      }

      this.odabraniRed = e.selectedRowsData[0];
      this.poslovnica_po_id = e.selectedRowsData[0].poslovnica_po_id;
      this.idOtpremnice = e.selectedRowsData[0].pz_id;
      this.partner_pa_id = e.selectedRowsData[0].partner_pa_id;
      this.statusDokumenta = e.selectedRowsData[0].pz_status;
      this.programKreiranja = e.selectedRowsData[0].pz_program_kreiranja;
      this.prometzag_pz_idVezni = e.selectedRowsData[0].prometzag_pz_id_vezni;

      if(e.selectedRowsData[0].pz_status == 'I'){
        this.dohvatiArtikleZaPoslovnicu().then((artPosl: any) =>{
          if (artPosl) {
            this.isLoading = false;
          }
        });

        this.artikli_u_cjeniku_za_partnera().then((artPosl: any) =>{
          if (artPosl) {
            this.isLoading = false;
          }
        });
      }

      this.dohvatiStavke();
    }

    if(this.redIzmjenjen == true) {
      this.dohvatiArtikleZaPoslovnicu().then((artPosl: any) =>{
        if (artPosl) {
          this.isLoading = false;
        }
      });

      this.artikli_u_cjeniku_za_partnera().then((artPosl: any) =>{
        if (artPosl) {
          this.isLoading = false;
        }
      });
    }
  }

  dohvatiPoslovnicePekar() {
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
    };
    this.poslovnicePekar = [];
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      if (res.success === true) {
        this.poslovnicePekar = res.data;
      }
    });
  }

  pretrazi(){
    this.zadnjId = null;
    this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
  }

  klikToLink(e) {
    sessionStorage.setItem("iddostavnica", e.data.iddostavnica);
  }

  povezaniDokumenti(data) {
    this.naslov = 'Popis povezanih dokumenata';
    let podaciZaSlanje = {
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
      access_token: this.access_token,
      pz_id: data.data.pz_id,
      dv_id: data.data.dokumentvrsta_dv_id
    }
    this.povezani_dokumenti = [];
    this.service.povezani_dokumenti_popis(podaciZaSlanje).subscribe(res => {
      this.povezaniDokumentiPopup = true;
      if (res.success == true) {
        this.povezani_dokumenti = res.data;
      } else {

      }
    });
  }

  uredu() {
    this.povezaniDokumentiPopup = false;
  }

  stornirajDokument(e) {
    this.zadnjId = null;
    let myDialog = custom({
      title: "Storniranje",
      messageHtml: "Jeste li sigurni da želite stornirati dokument i sve vezano uz njega?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          return { buttonText: e.component.option("text") }
        }
      },
      {
        text: "NE",
        onClick: (e) => {
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      if (dialogResult.buttonText === 'DA') {
        this.service.stornirajdokument({
          'idkorisnik': this.idkorisnik,
          'idfirma': this.idfirma,
          'pz_id': e.data.pz_id,
          'pz_broj': e.data.pz_broj
        }).subscribe(res => {
          if (res.success == true) {
            this.dohvatiOtpremnice(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
            notify('Uspješno ste stornirali dokumente.', 'success');
          } else {
            notify(res.message, 'error');
          }
        });
      } else { }
    });
  }


}
